<!-- 空白跳转也用来接收微信登录数据 -->
<template>
  <div>
    扫码成功，正在{{handlerType=='bind'?'绑定':'登录'}}...
  </div>
</template>

<script>
import { weixinLoginCheck, weixinBind } from "../../api/accountManage";
export default {
  data() {
    return {
      handlerType: 'login'
    }
  },
  mounted() {
    this.handlerType = this.$route.query.handlerType
    this.checkWeixin()
  },
  methods: {
    // 微信登录验证
    async checkWeixin() {
      if (this.handlerType === 'bind') {
        let res = await weixinBind(this.$route.query.code).catch((err) => {
          parent.BindBox(err)
        })
        // 登录后绑定
        parent.BindBox(res)
      } else {
        let res = await weixinLoginCheck({
          code: this.$route.query.code,
          platformType: 1,
          clientType: 1
        }).catch()
        if (res.data.wechatKey) {
          // 登录绑定微信
          parent.alertBindBox(res.data.wechatKey)
        } else {
          // 直接登录
          parent.weixinLogin(res)
        }
      }
    }
  }
}
</script>

<style>
</style>